var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerByIkiGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.031 5.78a7.74 7.74 0 003.77 3.769 7.74 7.74 0 00-3.77 3.77 7.74 7.74 0 00-3.77-3.77 7.74 7.74 0 003.77-3.77zM7.773 10.344c.595 1.19 1.389 1.984 2.58 2.58-1.191.594-1.985 1.388-2.58 2.579-.596-1.191-1.39-1.985-2.58-2.58 1.19-.595 1.985-1.389 2.58-2.58zM6.58 3.201c.595 1.19 1.388 1.984 2.579 2.58-1.19.595-1.984 1.388-2.58 2.579C5.984 7.17 5.19 6.376 4 5.78c1.19-.595 1.984-1.388 2.58-2.579z",
    fill: "#fff"
  })));
}
export default SvgMarkerByIkiGray;